import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { useLink } from '@grandvisionhq/frk-routing';
import { useIntl } from '@grandvisionhq/state';

const RxGlassesCTA = ({ action , onClickWhenOrderable , buttonRef , className , handleConversionEvent , bookAppointmentRouteConfig ,  })=>{
    const { getLabel  } = useIntl();
    const bookAppointmentLink = useLink(bookAppointmentRouteConfig !== null && bookAppointmentRouteConfig !== void 0 ? bookAppointmentRouteConfig : {
        route: 'appointments.book'
    });
    return action === 'OPEN_CONFIGURATOR' ? // Open Configurator button
    /*#__PURE__*/ React.createElement(Button, {
        caption: getLabel('products.actions.openConfigurator'),
        "data-t": "btn-open-configurator",
        onClick: onClickWhenOrderable,
        btnRef: buttonRef,
        className: className
    }) : // Book Appointment button
    /*#__PURE__*/ React.createElement(Button, {
        caption: getLabel('products.actions.bookAppointment'),
        "data-t": "btn-book-examination",
        href: bookAppointmentLink === null || bookAppointmentLink === void 0 ? void 0 : bookAppointmentLink.href,
        className: className,
        onClick: handleConversionEvent
    });
};

export { RxGlassesCTA };
//# sourceMappingURL=RxGlassesCTA.js.map
